import { render, staticRenderFns } from "./FileBlock.vue?vue&type=template&id=ab182676"
import script from "./FileBlock.vue?vue&type=script&lang=ts"
export * from "./FileBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports